import { 
    FaTrashAlt, 
    FaSearch, 
    FaShoppingCart, 
    FaHome, 
    FaUserAlt,
    FaInfo,
    FaMotorcycle 
} from 'react-icons/fa'
import { MdWatchLater } from 'react-icons/md'
import { useMenu } from '../../context/MenuContext'
import { formatMoney } from '../../Utils/formatMoney'

import { Content, Container, Search, MenuBar } from './style'


export function Header({ 
  searchTerm, 
  businessDatas, 
  handleSearchChange, 
  handleClearSearch, 
  listBuying,
  setInfoOpen,
  feeDelivery,
  loadingFeeDelivery
}) {

  const { handleSetIsBuyModalOpen } = useMenu()
  
  const deliveryFee = feeDelivery > 0
    ? `${formatMoney(feeDelivery)}`
    : `Grátis`

  return (
    <>
      <Container>
        <Content 
          logoImage={businessDatas.linkProfile}
          colorBg={businessDatas.colorBgHeader} 
          colorFont={businessDatas.colorLabel}
        >
          <header>
            <div className="logo"></div>

            <div className="informations">
              <div className="address">
                <h1>{businessDatas.name}</h1>
                <p>{businessDatas.street}, {businessDatas.number}</p>
                <p>{businessDatas.city}-{businessDatas.state}</p>   
                {
                  businessDatas.minValue > 0 
                    ? <p>
                        Pedido mínimo { formatMoney(businessDatas.minValue) }
                      </p>
                    : <></>
                }
                <p>{businessDatas.dadosAdicionais}</p>
              </div>

              <div 
                className="opened"
              >
                  {
                    (businessDatas.isOpenBusiness) ?
                      <div className="open">
                        <div />
                        <h4>Aberto</h4>
                      </div> 
                      :
                      <div className="closed">
                        <div />
                        <h4>Fechado</h4>
                      </div> 
                  }

                  <p
                    className="businessHours"
                    onClick={() => setInfoOpen(true)}
                  >
                    {businessDatas.businessHours}
                  </p>

                  
                  <p 
                    onClick={() => setInfoOpen(true)}
                    className="deliveryTime"
                  >
                    <MdWatchLater /> {businessDatas.minTimeDelivery} a {businessDatas.maxTimeDelivery}min
                  </p>
                  
                  {
                    loadingFeeDelivery ? <p>Carregando</p>
                    :
                    feeDelivery !== null && feeDelivery !== undefined && feeDelivery !== '' &&
                    <p className="deliveryFee">
                      <FaMotorcycle />
                      {deliveryFee}
                    </p>
                  }
              </div>
            </div>
          </header>

          <Search>
            <input
              type="search"
              placeholder="Buscar produto"
              value={searchTerm}
              onChange={handleSearchChange}
            />

            {
              (searchTerm.length !== "" && searchTerm.trim() !== "") 
                ? <FaTrashAlt onClick={handleClearSearch} /> 
                : <FaSearch />
            }
          </Search>
        </Content>
      </Container>


      {businessDatas.useOnlineOrder &&
        <MenuBar colorBg={businessDatas.colorBgBottom} colorFont={businessDatas.colorButtonBottom}>
          <FaHome />

          <div 
            className="item-bar" 
            onClick={() => { handleSetIsBuyModalOpen(true) }}
          >
            {
              listBuying !== undefined 
              ? <div className="items-shopping">{listBuying.length}</div> 
              : <></>
            }

            <FaShoppingCart />
          </div>

          <FaUserAlt 
            onClick={() => localStorage.getItem('@Inoveclube:token') 
              ?  window.location.href=`${process.env.REACT_APP_URL}profile` 
              :  window.location.href=`${process.env.REACT_APP_URL}login`
            } 
          />
          
          <FaInfo onClick={() => setInfoOpen(true)}/>
        </MenuBar>
      }
    </>
  );

}
